import { cn } from "@/libs/utils";
import DOMPurify from "dompurify";
import { ChevronIcon } from "src/components/support/assets/icons";
import { useMeasure } from "react-use";
import { GrayText } from "./Text";
import WordpressStyleDiv from "src/components/WordpressStyleDiv";

type Props = {
  className?: string;
  title: string;
  content: string;
  opened: boolean;
  onToggleOpen: (e: any) => void;
};

export function Accordion({
  className,
  title,
  content,
  opened,
  onToggleOpen,
}: Props) {
  const [ref, { x, y, width, height, top, right, bottom, left }] =
    useMeasure<HTMLDivElement>();
  return (
    <div className="w-full">
      <button
        onClick={onToggleOpen}
        className={cn("flex w-full items-center justify-between gap-x-2 py-5", {
          "border-b-[1px] border-coolgray-20": opened,
        })}
      >
        <div className="grow text-left">
          <GrayText
            className={cn("text-lg font-400 leading-[20px] smd:text-[20px]", {
              "font-600": opened,
            })}
            text={title.replace(/&lt;/g, "<").replace(/&gt;/g, ">")}
          />
        </div>
        <div className="w-[11px]">
          <ChevronIcon width={11} height={6} dir={opened ? "left" : "right"} />
        </div>
      </button>
      <div
        style={{
          height: opened ? height + 80 : 0,
        }}
        className={cn(
          "ease-[cubic-bezier(0.4,0,0.2,1)] transition-[height] duration-300",
          opened ? "" : "h-0",
          "overflow-y-hidden",
        )}
      >
        <div
          ref={ref}
          className={cn(
            "border-b-[1px] border-coolgray-20 pb-[50px] pt-[30px]",
          )}
        >
          <WordpressStyleDiv>
            <div
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
            />
          </WordpressStyleDiv>
        </div>
      </div>
    </div>
  );
}
